import { render, staticRenderFns } from "./StoriesStats.vue?vue&type=template&id=097462dc&scoped=true&"
import script from "./StoriesStats.vue?vue&type=script&lang=js&"
export * from "./StoriesStats.vue?vue&type=script&lang=js&"
import style0 from "./StoriesStats.vue?vue&type=style&index=0&id=097462dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097462dc",
  null
  
)

component.options.__file = "StoriesStats.vue"
export default component.exports